import {
  BakeShadows,
  Environment,
  Lightformer,
  OrbitControls,
  PerspectiveCamera,
  Preload,
  Stage,
} from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { twMerge } from "tailwind-merge";
import { KadeurdeurDoor } from "./doors/kader/enkel/KaderdeurDoor";
import KaderdeurDubbelV2 from "./doors/kader/enkel/KaderdeurDubbelV2";
import { KaderdeurKozijn } from "./doors/kader/enkel/KaderdeurKozijn";
import { BackgroundChair } from "./doors/kader/enkel/BackgroundChair";

interface DoorProps {
  className?: string;
  doorClassName?: string;
}

const BusinessProductScene = ({ className = "", doorClassName }: DoorProps) => {
  const { selectedDoor, eigenwijs } = useConfigurationOptionsContext();

  return (
    <div
      className={twMerge(
        "gg-grid gg-cursor-pointer gg-grid-cols-12 lg:gg-gap-2",
        className,
      )}
    >
      <div className={twMerge(doorClassName)} data-testid="door-scene">
        <Canvas shadows>
          {/* Environment for overall studio lighting */}
          <color
            attach="background"
            // args={["#d6d6d6"]}
            args={["#f0f0f0"]}
            // args={["#bdbdbd"]}
          />
          <PerspectiveCamera makeDefault position={[0, 0, 3.5]} />
          <Environment preset="city">
            <Lightformer
              form="rect"
              intensity={1} // Brightness of the light
              position={[0, 5, -5]} // Place it above and behind the door
              scale={[10, 5, 1]} // Shape of the light
            />
            <Lightformer
              form="ring"
              intensity={1}
              position={[2, 3, 2]} // Offset for dramatic effect
              scale={[4, 4, 1]} // Circular light source
            />
          </Environment>
          {/* Stage provides a ground plane and lighting */}
          {/* <Stage adjustCamera={1.1} shadows="contact"> */}
          {/* Door model placed on the stage */}

          {selectedDoor?.code === "kaderdeur" && (
            <Stage adjustCamera={false} shadows="contact">
              <KadeurdeurDoor />
            </Stage>
          )}
          {selectedDoor?.code === "dubbelekaderdeur" && (
            <Stage adjustCamera={false} shadows="contact">
              <KaderdeurDubbelV2 />
            </Stage>
          )}
          {selectedDoor?.code === "zakelijkkozijn" && (
            <Stage adjustCamera={false} shadows="contact">
              <KaderdeurKozijn />
            </Stage>
          )}
          <BackgroundChair />

          {/* </Stage> */}

          {/* Additional light shaping using Lightformer */}
          <Preload all />
          <BakeShadows />
          {/* Controls for orbiting and inspecting the scene */}
          <OrbitControls
            enablePan={false}
            maxPolarAngle={Math.PI / 2}
            enableZoom={false}
          />
        </Canvas>
      </div>
    </div>
  );
};
export default BusinessProductScene;
